<template>
  <cv-list :nested="isNested">
    <slot />
  </cv-list>
</template>

<script setup lang="ts">
const instance = getCurrentInstance();
const isNested = instance?.parent?.parent?.type.name === "CvListItem";
</script>
